export const WEEK = [
  ['日', 'sun', 0],
  ['月', 'mon', 1],
  ['火', 'tue', 2],
  ['水', 'wed', 3],
  ['木', 'thu', 4],
  ['金', 'fri', 5],
  ['土', 'sat', 6],
] as const;
